import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
  fetchUser as fetchUserAPI,
  updateUserAvatar as updateUserAvatarApi,
  updateUserSettings,
} from 'spw-api';
import { APIResponse } from 'spw-redux/types';
import { handleError } from 'spw-redux/modules/UI/messages/actions';
import { selectSelectedUser } from 'spw-redux/modules/users/selectors';
import { getSelectedUserSucceeded } from 'spw-redux/modules/users/actions';
import { currentUser as selectCurrentUser } from 'spw-redux/modules/user/selectors';
import { logout } from 'spw-redux/modules/auth/actions';
import {
  actions,
  FETCH_USER,
  UPDATE_USER_AVATAR,
  CHANGE_MEASUREMENT_SYSTEM,
} from './actions';
import { IUser } from './types';
import { fetchOrg } from '../organization/actions';

function* fetchUser() {
  try {
    const response: APIResponse<typeof fetchUserAPI> = yield call(fetchUserAPI);
    const user: IUser = response.data.currentUser;

    if (!user.isActive) {
      yield put(logout());
      return;
    }

    Sentry.setUser({
      id: user.id.toString(),
      email: user.id.toString(),
      username: user.id.toString(),
      orgId: user.organizationId.toString(),
    });

    yield put(actions.fetchUserSucceeded(user));
    yield put(fetchOrg());
  } catch (e) {
    yield put(handleError(e));
  }
}

function* updateUserAvatar(
  action: ReturnType<typeof actions.updateUserAvatar>
) {
  try {
    const { form, onSuccess } = action.payload;

    const currentUser: IUser = yield select(selectCurrentUser);
    const selectedUser: IUser | null = yield select(selectSelectedUser);

    const response: APIResponse<typeof updateUserAvatarApi> = yield call(
      updateUserAvatarApi,
      form
    );
    const updatedUser = response.data.user;

    if (updatedUser.id === currentUser.id) {
      yield put(
        actions.updateUserAvatarSucceeded({
          id: updatedUser.id,
          hasAvatar: updatedUser.hasAvatar,
          thumbnailS3Path: updatedUser.thumbnailS3Path,
        })
      );
    }

    if (selectedUser && selectedUser.id === updatedUser.id) {
      yield put(
        getSelectedUserSucceeded({
          ...selectedUser,
          hasAvatar: updatedUser.hasAvatar,
          thumbnailS3Path: updatedUser.thumbnailS3Path,
        })
      );
    }
    if (onSuccess) yield call(onSuccess);
  } catch (e) {
    yield put(handleError(e));
  }
}

function* changeMeaurementSystemCall(
  action: ReturnType<typeof actions.changeMeasurementSystem>
) {
  try {
    yield call(updateUserSettings, { measurementSystemWeb: action.payload });
  } catch (e) {
    yield put(handleError(e));
  }
}

function* saga() {
  yield all([
    takeLatest(FETCH_USER, fetchUser),
    takeLatest(UPDATE_USER_AVATAR, updateUserAvatar),
    takeLatest(CHANGE_MEASUREMENT_SYSTEM, changeMeaurementSystemCall),
  ]);
}

export default saga;
